import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/physical-security/compact/g5-flex.png";
import { type Product } from "../../types";
import { compact as physicalSecurityCompact } from "../product-list-groups/compact";
import { deployment } from "../properties/deployment";
import { outdoorReady } from "../properties/outdoorReady";

export const g5Flex: Product = {
  id: "g5Flex",
  productTitle: "G5 Flex",
  techspecsPath: [SiteId.TechSpecs, "/unifi/cameras-nvrs/uvc-g5-flex"],
  storePathParts: { productSlug: "uvc-g5-flex", category: "cameras-compact" },
  sku: "UVC-G5-Flex",
  description: "g5Flex.description",
  descriptionMaxWidth: 200,
  image: { src: image, width: 200, height: 140 },
  productListGroup: physicalSecurityCompact,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: 'Ø48 x 107.5 mm\n(Ø1.9 x 4.2")',
      },
    },
    {
      propertyId: "cameraResolution",
      value: { type: "string", value: "2K" },
    },
    {
      propertyId: "imageSensor",
      value: { type: "string", value: "5MP CMOS" },
    },
    {
      propertyId: "fieldOfView",
      value: {
        type: "translation",
        value: "g5Flex.fieldOfView",
      },
    },
    {
      propertyId: "nightVision",
      value: { type: "string", value: "6 m (20 ft)" },
    },
    {
      propertyId: "opticalZoom",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "smartDetections",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "faceRecognition",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "enhancedDetections",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "licensePlateRecognition",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "aiRecognition",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "cameraAudio",
      value: { type: "translation", value: "commons.cameraAudio.microphone" },
    },
    {
      propertyId: outdoorReady.id,
      value: {
        type: "translation",
        value: "g5Flex.outdoorReady",
      },
    },
    {
      propertyId: "tamperResistance",
      value: { type: "string", value: "IK04" },
    },
    {
      propertyId: deployment.id,
      value: { type: "string", value: "PoE" },
    },
  ],
};
